import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-waitlist-dialog',
    imports: [MatDialogModule, MatButtonModule, MatIconModule],
    templateUrl: './waitlist-dialog.component.html',
    styleUrl: './waitlist-dialog.component.css'
})
export class WaitlistDialogComponent {
  // constructor(private dialog: MatDialog) {}
  // openDialog(
  //   enterAnimationDuration: string,
  //   exitAnimationDuration: string
  // ): void {
  //   this.dialog.open(AddListComponent, {
  //     enterAnimationDuration,
  //     exitAnimationDuration,
  //     width: '700px',
  //   });
  // }
}
